import { render } from "./userAttributesBubbles.vue?vue&type=template&id=6e54a9ed"
import script from "./userAttributesBubbles.vue?vue&type=script&lang=js"
export * from "./userAttributesBubbles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__